import React, { useRef } from 'react';
import styled from 'styled-components'


const ScrollText = styled.div``

const ScrollingText = ({ text }) => {
  const scrollTextRef = useRef(null)

  return (
    <div style={{ height: 28, overflow: 'hidden'}}>
      <ScrollText
        ref={scrollTextRef}
        onMouseEnter={(e) => {
          scrollTextRef.current.classList.remove("scroll-down")
          scrollTextRef.current.classList.add("scroll-up")

        }}
        onMouseLeave={(e) => {
          scrollTextRef.current.classList.remove("scroll-up")
          scrollTextRef.current.classList.add("scroll-down")

        }}
      >
        <div>{text}</div>
        <div>{text}</div>
        <div>{text}</div>
      </ScrollText>
    </div>
  )
}

export default ScrollingText;